import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import App from '@app';
import { Body, PageHeader, FormCadastro, Select, View, Field, GroupField, Input, SubmitButton } from '@components';
import { getTodosClientes } from '@sdk/Clientes';
import { getConfiguracoesDesbloqueadas } from '@sdk/Conectores/Configuracoes';
import { getBloqueios, postBloqueio } from '@ducks/conectoresBloqueios';
import TableBloqueio from './TableBloqueios';
import styled from 'styled-components';

const FormCadastroStyled = styled(FormCadastro)`
  width: 100%;
  margin-bottom: 15px;
`;

const FieldCliente = styled(Field)`
  margin-bottom: 15px;
  flex: 1;
`;

const FieldConector = styled(Field)`
  margin-bottom: 0;
  flex: 1;
`;

const ViewConector = styled(View)`
  margin-bottom: 0;
  flex: 1;
  margin-right: 15px;
`;

const FieldConectorManual = styled(Field)`
  margin-bottom: 0;
  flex: 1;
`;

const ViewConectorManual = styled(View)`
  margin-bottom: 0;
  flex: 1;
  margin-right: 15px;
`;

const ViewDisabled = styled(View)`
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
`;

export default function Bloqueios() {
  const dispatch = useDispatch();
  const [form] = FormCadastroStyled.useForm();
  const [idCliente, setIdCliente] = useState(-1);
  const [conectorIdentify, setConectorIdentify] = useState(null);
  const [configuracoesDesbloqueadas, setConfiguracoesDesbloqueadas] = useState([]);

  const successPostBloqueio = useSelector(({ conectoresBloqueios }) => conectoresBloqueios.get('successPostBloqueio'));
  const successDeleteBloqueio = useSelector(({ conectoresBloqueios }) => conectoresBloqueios.get('successDeleteBloqueio'));

  const handleSearch = () => {
    dispatch(getBloqueios());
  };

  const handleReset = () => {
    form.resetFields();
    setConfiguracoesDesbloqueadas([]);
    setIdCliente(-1);
    setConectorIdentify(null);
  };

  useEffect(() => {
    if (idCliente !== -1) {
      getConfiguracoesDesbloqueadas(idCliente).then((response) => {
        setConfiguracoesDesbloqueadas([]);
        setConfiguracoesDesbloqueadas(response);
      });
    } else {
      setConfiguracoesDesbloqueadas([]);
    }
  }, [idCliente]);

  useEffect(() => {
    if (successPostBloqueio) {
      handleSearch();
      handleReset();
    }
  }, [successPostBloqueio]);

  useEffect(() => {
    if (successDeleteBloqueio) {
      handleReset();
    }
  }, [successDeleteBloqueio]);

  const getConfiguracoes = async () => {
    return configuracoesDesbloqueadas;
  };

  const handleSubmit = (data) => {
    if (data.conectorIdentifyManual) {
      data.conectorIdentify = data.conectorIdentifyManual;
      delete data.conectorIdentifyManual;
    }
    dispatch(postBloqueio(data));
  };

  return (
    <App>
      <Body>
        <PageHeader title="Bloqueio de Conectores">
          <FormCadastroStyled form={form} hideRequiredMark onFinish={handleSubmit}>
            <GroupField>
              <FieldCliente label="Cliente" name="idCliente" rules={[{ required: true, message: 'Informe o cliente' }]}>
                <Select
                  form={form}
                  id="idCliente"
                  name="idCliente"
                  action={() => getTodosClientes()}
                  placeholder="Selecione um cliente"
                  onChange={(value) => setIdCliente(value)}
                  autoFocus
                />
              </FieldCliente>
              {configuracoesDesbloqueadas.length > 0 ? (
                <FieldConector label="Conector cadastrado" name="conectorIdentify">
                  <Select
                    form={form}
                    name="id"
                    action={() => getConfiguracoes()}
                    placeholder="Selecione um conector"
                    onChange={(value) => setConectorIdentify(value)}
                  />
                </FieldConector>
              ) : (
                <ViewConector>
                  <ViewDisabled>Conector cadastrado</ViewDisabled>
                  <Select action={() => getConfiguracoes()} placeholder="Selecione um conector" disabled />
                </ViewConector>
              )}
              {conectorIdentify === null || conectorIdentify === 'Não cadastrado' ? (
                <FieldConectorManual
                  label="Conector"
                  name="conectorIdentifyManual"
                  rules={[{ required: true, message: 'Informe o conector' }]}
                >
                  <Input />
                </FieldConectorManual>
              ) : (
                <ViewConectorManual>
                  <ViewDisabled>Conector</ViewDisabled>
                  <Input disabled />
                </ViewConectorManual>
              )}
            </GroupField>
            <SubmitButton type="danger" htmlType="submit" block>
              Bloquear
            </SubmitButton>
          </FormCadastroStyled>
          <TableBloqueio />
        </PageHeader>
      </Body>
    </App>
  );
}
